import React, { JSX } from 'react';
import { Button } from 'reactstrap';
import { Select } from '../../Form/Select/Select';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { range } from 'lodash-es';
import dayjs from 'dayjs';

const getMonth = (val: Date): number => {
  return dayjs(val).month();
};

const getYear = (val: Date): number => {
  return dayjs(val).year();
};

const months = range(0, 12, 1);

const years = range(getYear(new Date()), getYear(new Date()) + 3, 1).map(y => {
  return { value: y.toString(), label: y.toString() };
});

const renderCustomHeader = (
  params: ReactDatePickerCustomHeaderProps & {
    locale?: string;
  }
): JSX.Element => {
  const {
    date: paramDate,
    monthDate,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    customHeaderCount,
    locale
  } = params;
  const currentYear = new Date().getFullYear();
  const monthShortFormatter = new Intl.DateTimeFormat(locale, { month: 'short' });
  const monthLongAndYearFormatter = new Intl.DateTimeFormat(locale, {
    month: 'long',
    year: 'numeric'
  });

  const monthOptions = months.map(monthIndex => {
    const dateOfMonth = new Date(currentYear, monthIndex);
    const label = monthShortFormatter.format(dateOfMonth);

    return {
      value: monthIndex.toString(),
      label
    };
  });

  // panel current month
  if (customHeaderCount === 0) {
    return (
      <>
        <div className="react-datepicker__select__wrapper react-datepicker__select__wrapper--month">
          <Select
            options={monthOptions}
            selectedOption={{
              label: getMonth(paramDate).toString(),
              value: getMonth(paramDate).toString()
            }}
            onChange={(m): void => changeMonth(+m.value)}
            getValue={(m): string => m.value}
            getLabel={(m): string => monthOptions[+m.value].label}
          />
        </div>
        <div className="react-datepicker__current_month-with-nav-button">
          <Button
            className="react-datepicker__header-nav-button"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            outline
          >
            <span className="text-primary">{'<'}</span>
          </Button>

          <h3 className="react-datepicker__month-name react-datepicker__current-month">
            {monthLongAndYearFormatter.format(monthDate)}
          </h3>
        </div>
      </>
    );
  }

  // panel following month
  return (
    <>
      <div className="react-datepicker__select__wrapper react-datepicker__select__wrapper--year">
        <Select
          options={years}
          className="react-datepicker__select"
          selectedOption={{
            label: getYear(paramDate).toString(),
            value: getYear(paramDate).toString()
          }}
          onChange={(y): void => changeYear(+y.value)}
          getValue={(y): string => y.value}
          getLabel={(y): string => y.label}
        />
      </div>
      <div className="react-datepicker__next_month-with-nav-button">
        <h3 className="react-datepicker__month-name react-datepicker__current-month">
          {monthLongAndYearFormatter.format(monthDate)}
        </h3>
        <Button
          className="react-datepicker__header-nav-button"
          size="sm"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          outline
        >
          <span className="text-primary">{'>'}</span>
        </Button>
      </div>
    </>
  );
};

export default renderCustomHeader;
